const generateHash = () => {
    return Math.random().toString(36).slice(2, 8);
};
export default generateHash;
